import { jsx as _jsx } from "react/jsx-runtime";
import { Shimmer } from '@fluentui/react';
import { lazy, Suspense } from 'react';
const LazyVulnReportTimeline = lazy(() => import('./VulnReportTimeline').then(c => ({
    default: c.VulnReportTimeline,
})));
/** Details view of a vuln report focused primarily on comms/timeline. */
export const VulnReportTimeline = (props) => {
    return (_jsx(Suspense, Object.assign({ fallback: _jsx(Shimmer, {}) }, { children: _jsx(LazyVulnReportTimeline, Object.assign({}, props)) })));
};
